import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import moment from 'moment';
import { RootState, MyThunkDispatch } from 'store';

import { fetchAllUsersActive } from 'actions/adminUser';
import { fetchCostCenterReportView } from 'actions/costCenter';
import { fetchAllGroupListActive } from 'actions/group';
import { fetchReportSummary } from 'actions/reports';
import { CostCenterReportRequest, CostCenterReportResponse } from 'models/costCenterReport';
import { TravelReportRequest as Filters } from 'models/reportSummary';
import TravelReport from 'screens/components/TravelReport';

const TravelReportContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();

  const {
    report: { filters, reportSummary, isLoading },
    group: { groupList },
    user: { accountResult },
    adminUser: { adminUserList },
  } = useSelector((state: RootState) => state);

  const [costCenterReport, setCostCenterReport] = useState<CostCenterReportResponse>();
  const [isLoadingCostCenterReport, setIsLoadingCostCenterReport] = useState<boolean>(false);
  const handleFetchGroupList = () => dispatch(fetchAllGroupListActive());
  const handleFetchUsersAndInvites = (companyId: string) => dispatch(fetchAllUsersActive(companyId));
  const handleFetchReportSummary = (companyId?: string, filter?: Filters) =>
    dispatch(fetchReportSummary(companyId, filter));

  const handleFetchCostCenterReport = async (filters: CostCenterReportRequest) => {
    setIsLoadingCostCenterReport(true);
    try {
      const {
        data: { data },
      } = await fetchCostCenterReportView(filters);
      setCostCenterReport(data);
      setIsLoadingCostCenterReport(false);
    } catch (e) {
      setIsLoadingCostCenterReport(false);
    }
  };

  useEffect(() => {
    const handleFetchSummary = () => {
      const data: Filters = {
        FilterStartDate: moment().subtract('30', 'days').toISOString(),
        FilterEndDate: moment().toISOString(),
      };

      handleFetchReportSummary(accountResult?.companyId, data);
    };
    handleFetchSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountResult?.companyId]);

  //el endpoint Reports/TravelsListReport no devuelve currency, entonces passamos el currency global del redux
  const handleReportSummaryCurrency = (reportSummary) => ({
    ...reportSummary,
    currency: reportSummary?.currency || accountResult?.countryCurrency || '',
  });

  return (
    <TravelReport
      groupList={groupList}
      accountResult={accountResult}
      adminUserList={adminUserList?.filter((user) => !user.isInvite)}
      fetchGroupList={handleFetchGroupList}
      fetchUsersAndInvites={handleFetchUsersAndInvites}
      fetchReportSummary={handleFetchReportSummary}
      fetchCostCenterReport={handleFetchCostCenterReport}
      filters={filters}
      travelReport={handleReportSummaryCurrency(reportSummary)}
      isLoading={isLoading}
      isLoadingCostCenterReport={isLoadingCostCenterReport}
      costCenterReport={costCenterReport}
    />
  );
};

export default TravelReportContainer;
